import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import {getCharge, getClient} from "../../api";
import {useParams} from "react-router-dom";
import {Client} from "../../types";


const PrintCharge: React.FunctionComponent = () => {

    const {clientId, chargeId} = useParams();
    const [amount, setAmount] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [description, setDescription] = useState("");
    const [client, setClient] = useState<Client>()

    const load = useCallback(() => {
        getCharge(clientId, chargeId)
            .then((c) => {
                setAmount("" + c.amount);
                setCreatedAt(c.chargeDate);
                setDescription(c.description);
            });

        getClient(clientId)
            .then((c) => {
                setClient(c);
            })
    }, [clientId, chargeId])

    useEffect(() => {
        load();
    }, [load]);


    return <>
        <h3>Charge Receipt</h3>

        <h5>Bill To</h5>
        <p>
            Name: {client?.firstName + " " + client?.lastName}<br />
            Email: {client?.email}<br />
            Address: <br/>
            {client?.address.addressLine1}<br />
            <span hidden={!client?.address.addressLine2}>{client?.address.addressLine2}<br /></span>
            {client?.address.city} {client?.address.state} {client?.address.zip}<br />
        </p>
        <h5>Remit To</h5>
        <p>
            Promises12<br />
            65 Corban Ave STE 7<br />
            Concord, NC 28025
        </p>
        <h5>Transaction Details</h5>
        <p>
            Date: {createdAt}<br/>
            Amount: ${amount}<br/>
            Description: {description}<br />
        </p>
    </>
}

export default PrintCharge;